export default "__VITE_ASSET__4e2d74b5__"